import React, { useEffect, useState } from 'react';
import {useSettings} from "../SettingsContext";

const FloatingActionButtons = () => {
    const setting = useSettings();
    const [showScrollTop, setShowScrollTop] = useState(false);
    const [hoveredBtn, setHoveredBtn] = useState(null);

    // Dynamic Contact Links (Apnar info onujayi ekhane number/username diben)
    // const whatsappNumber = {setting?email};
    // const messengerUsername = "yourpageid";   // Facebook page username/ID
    // const phoneNumber = "+8801700000000";

    // Show scroll-to-top button after 300px scroll
    useEffect(() => {
        const toggleVisibility = () => {
            setShowScrollTop(window.scrollY > 300);
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    // Base Button Style
    const getButtonStyle = (btnKey, bgColor) => ({
        width: '45px',
        height: '45px',
        borderRadius: '50%',
        backgroundColor: bgColor,
        color: '#ffffff',
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '20px',
        cursor: 'pointer',
        textDecoration: 'none',
        boxShadow: hoveredBtn === btnKey
            ? '0 6px 16px rgba(0,0,0,0.3)'
            : '0 4px 10px rgba(0,0,0,0.15)',
        transform: hoveredBtn === btnKey ? 'scale(1.1)' : 'scale(1)',
        transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    });

    return (
        <div
            style={{
                position: 'fixed',
                bottom: '25px',
                right: '25px',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                zIndex: 9999,
                alignItems: 'center',
            }}
        >
            {/* 1. Phone Call Button */}
            <a
                href={`tel:${setting?.header_phone}`}
                style={getButtonStyle('call', '#28a745')}
                onMouseEnter={() => setHoveredBtn('call')}
                onMouseLeave={() => setHoveredBtn(null)}
                aria-label="Call Us"
                title="Call Us"
            >
                <i className="fas fa-phone-alt" style={{ fontSize: '18px' }}></i>
            </a>

            {/* 2. WhatsApp Button */}
            <a
                href={`https://wa.me/${setting?.whatsApp}`}
                target="_blank"
                rel="noopener noreferrer"
                style={getButtonStyle('whatsapp', '#25D366')}
                onMouseEnter={() => setHoveredBtn('whatsapp')}
                onMouseLeave={() => setHoveredBtn(null)}
                aria-label="Chat on WhatsApp"
                title="WhatsApp"
            >
                <i className="fab fa-whatsapp" style={{ fontSize: '24px' }}></i>
            </a>

            {/* 3. Messenger Button */}
            <a
                href={`https://m.me/${setting?.messenger}`}
                target="_blank"
                rel="noopener noreferrer"
                style={getButtonStyle('messenger', '#0084FF')}
                onMouseEnter={() => setHoveredBtn('messenger')}
                onMouseLeave={() => setHoveredBtn(null)}
                aria-label="Chat on Facebook Messenger"
                title="Messenger"
            >
                <i className="fab fa-facebook-messenger" style={{ fontSize: '22px' }}></i>
            </a>

            {/* 4. Scroll To Top Button (Shows only on scroll) */}
            {showScrollTop && (
                <button
                    onClick={scrollToTop}
                    style={getButtonStyle('scrollTop', '#007bff')}
                    onMouseEnter={() => setHoveredBtn('scrollTop')}
                    onMouseLeave={() => setHoveredBtn(null)}
                    aria-label="Scroll to top"
                    title="Scroll to Top"
                >
                    <i className="fas fa-arrow-up" style={{ fontSize: '18px' }}></i>
                </button>
            )}
        </div>
    );
};

export default FloatingActionButtons;